import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { getAssetUrl } from "../../helpers/getAssetUrl";

class RestaurantSlider extends Component {
	render() {
		const { slides, size, secondarySlider } = this.props;
		const responsive = {
			desktop: {
			  breakpoint: { max: 3000, min: 1024 },
			  items: 3,
			  partialVisibilityGutter: 60
			},
			tablet: {
			  breakpoint: { max: 1024, min: 464 },
			  items: 2,
			  partialVisibilityGutter: 60
			},
			mobile: {
			  breakpoint: { max: 464, min: 300 },
			  items: 1,
			  partialVisibilityGutter: 80
			},
		};
		return (
			<React.Fragment>
				{slides.length === 0 ? (
				<ContentLoader
					height={170}
					width={400}
					speed={1.2}
					primaryColor="#f3f3f3"
					secondaryColor="#ecebeb"
				>
					<rect x="20" y="0" rx="4" ry="4" width="168" height="168" />
					<rect x="228" y="0" rx="4" ry="4" width="168" height="168" />
				</ContentLoader>
				):(
				<React.Fragment>
					<Carousel
						additionalTransfrom={0}
						swipeable={true}
						arrows={false}
						autoPlay={true}
						autoPlaySpeed={5000}
						centerMode={false}
						className={""}
						containerClass={""}
						customTransition={"all .5s linear"}
						dotListClass={""}
						draggable={true}
						focusOnSelect={false}
						infinite={true}
						itemClass={""}
						keyBoardControl={true}
						minimumTouchDrag={20}
						partialVisible={true}
						pauseOnHover={true}
						renderArrowsWhenDisabled={false}
						renderButtonGroupOutside={false}
						renderDotsOutside={true}
						responsive={responsive}
						rewind={false}
						rewindWithAnimation={false}
						rtl={false}
						shouldResetAutoplay={true}
						showDots={false}
						sliderClass={""}
						>
						{slides.map((slide) => slide && (
							<a key={slide.id} className="banner-carousel--banner full" href={slide.url}>
								<div className="image-overlay">
								<div className="image-overlay--overlay "></div>
								<img src={getAssetUrl(slide.image)} alt="Banner" />
								</div>
							</a>
						))}
					</Carousel>
				</React.Fragment>
				)}
				
			</React.Fragment>
		);
	}
}

export default RestaurantSlider;
